import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { localize } from '../i18n';

const Tab = function Tab(props) {
  const {
    tabs,
    content,
    activeTab,
    onChange,
  } = props;
  const tabContent = [];

  const tabItems = tabs.map((item) => {
    const tabItemClasses = [];
    let ariaExpanded = false;
    const tabContentClasses = [];
    let ariaHidden = true;
    let disabled = false;
    if (_.has(item, 'disabled')) {
      disabled = item.disabled;
    }
    if (disabled === true) {
      tabItemClasses.push('uk-disabled');
    } else if (activeTab === item.tab) {
      tabItemClasses.push('uk-active');
      ariaExpanded = true;
      tabContentClasses.push('uk-active');
      ariaHidden = false;
    }
    tabContent.push((
      <li key={`tab-content-${item.tab}`} aria-hidden={ariaHidden} className={tabContentClasses.join(' ')}>
        {content[item.tab] || props.t('Tab Content missing for: {itemTab}', { itemTab: item.tab })}
      </li>
    ));
    return (
      <li key={`tab-${item.label.toLowerCase()}`} className={tabItemClasses.join(' ')} aria-expanded={ariaExpanded}>
        <a
          href={`#tab-${item.label.toLowerCase()}`}
          onClick={() => {
            if (disabled === false) {
              onChange(item.tab);
            }
          }}
        >
          {props.t(item.label)}
        </a>
      </li>
    );
  });

  return (
    <div>
      <ul className="uk-tab">
        {tabItems}
      </ul>
      <ul className="uk-switcher uk-margin">
        {tabContent}
      </ul>
    </div>
  );
};

Tab.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    tab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  })),
  content: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ])),
  activeTab: PropTypes.string,
  onChange: PropTypes.func,
  t: PropTypes.func.isRequired,
};

Tab.defaultProps = {
  onChange: () => {},
};

export default localize(Tab);



// WEBPACK FOOTER //
// ./src/components/Tab.js